import React, { useState,useEffect } from 'react';

const MyComponent = () => {
useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
}, []);

  return (
    <div>
      
    </div>
  );
};

export default MyComponent;